import AiSecurityExperience from '@comp/ai/ai-security-experience'

export default function IdentityCopilotPage({ locale }: { locale: string }) {
  return <AiSecurityExperience page="copilot" locale={locale} />
}

export async function getStaticProps({ locale }: { locale: string }) {
  return { props: { locale: locale ?? 'en' } }
}
